export default "__VITE_ASSET__YMxAQnej__"